import { library, dom } from '@fortawesome/fontawesome-svg-core';

// フリー
// ---------------
import {
    faHome,
    faTags,
    faPencilAlt,
    faEraser,
    faBookOpen,
    faChevronDown,
    faAngleRight,
    faBars,
    faEnvelope,
    faPhone,
    faFax,
    faLink,
    faArrowAltCircleRight
} from '@fortawesome/free-solid-svg-icons';

import {
} from '@fortawesome/free-regular-svg-icons';

import {
} from '@fortawesome/free-brands-svg-icons';


library.add(
    faHome,
    faTags,
    faEnvelope,
    faPencilAlt,
    faEraser,
    faBookOpen,
    faChevronDown,
    faAngleRight,
    faBars,
    faEnvelope,
    faPhone,
    faFax,
    faLink,
    faArrowAltCircleRight
);

dom.watch();